export default __webpack_public_path__ + "static/media/Billing-Adress.26f0d2ca.jpg";